import { StoreContext } from '../../models/store/context';

/**
 *
 * @param state
 * @returns  boolean | undefined
 *
 * This function checks if the current state of the store indicates that the user has selected a replacement care plan.
 *
 * If the first contract in the offer has a fixed term single payment attribute, which indicates that the user has selected a replacement care plan.
 * If there is no quote or if it does not have data, it checks if there is a confirmation in the state and if it has purchase data.
 * It checks if the plan type is 'replacement-care', which also indicates that the user has selected a replacement care plan.
 * If neither of these conditions are met, it returns undefined.
 */

export const isReplacementCare = (state: StoreContext): boolean | undefined => {
  const { quote, confirmation } = state;

  try {
    if (quote && quote.data) {
      return !!quote.data.offer.contracts[0].contractAttributes.fixed_term_single_payment;
    }

    if (confirmation && confirmation.purchaseData) {
      return confirmation.purchaseData.planType === 'replacement-care';
    }
  } catch (error) {
    console.error('Error selecting replacement care from store', error);
    return undefined;
  }
};
